import { TrackingMetadata } from '@terminal/services/tracking/posthog/constants';
import { useChatNavigation } from '@terminal/views/alfred/use-chat-navigation/useChatNavigation';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ChatDeepAnalysis } from './chat-deep-analysis/ChatDeepAnalysis';
import { ChatDocumentSearch } from './chat-document-search/ChatDocumentSearch';
import { ChatQuickAnalysis } from './chat-quick-analysis/ChatQuickAnalysis';
import { ChatInputConfig } from './types';

export interface ChatInputProps {
  submitCallback?: (message?: string) => void;
  chatContext?: {
    documents?: string[];
    documentTypes?: string[];
    entityTags?: string[];
  };
  config?: ChatInputConfig;
  trackingMetadata?: TrackingMetadata;
}

export const ChatInput = ({
  submitCallback,
  chatContext,
  config,
  trackingMetadata,
}: ChatInputProps) => {
  useTranslation(['chat']);
  const { mode } = useChatNavigation();

  if (mode === 'document' || chatContext) {
    return (
      <ChatDocumentSearch
        config={config}
        submitCallback={submitCallback}
        chatContext={chatContext}
        trackingMetadata={trackingMetadata}
      />
    );
  }

  if (mode === 'quickAnalysis') {
    return (
      <ChatQuickAnalysis
        config={config}
        submitCallback={submitCallback}
        trackingMetadata={trackingMetadata}
      />
    );
  }

  return (
    <ChatDeepAnalysis
      config={config}
      submitCallback={submitCallback}
      trackingMetadata={trackingMetadata}
    />
  );
};
